module.exports = __webpack_public_path__ + "images/stickers/pete-ghost@2x.4a28ad313694864c5a66.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-ghost@2x.png
// module id = AyCR
// module chunks = 24